<template>
  <div class="page_candidate">
    <router-view></router-view>
  </div>
</template>

<script>
  import xz from "@/common";
  export default {
    data() {
      return {}
    },
    async created() {
      this.$store.commit('setHiddenLeft', true)
    },
    methods: {}
  }
</script>
<style scoped>
</style>